import React from 'react';
import styles from '../NewLogin.module.scss';
import TokenForm from 'Pages/Auth/TwoStepAuthentication/components/TokenForm';
import { useTranslation } from 'react-i18next';

const VerificationCodeBlock: React.FC = () => {
	const { t } = useTranslation();

	return (
		<div className={styles.contentBlock}>
			<h1 className={styles.title}>{t('twoFactorAuthorization.verification.title')}</h1>
			<p className={styles.authDescription}>
				{`${t('twoFactorAuthorization.verification.description.p1')} ${t('twoFactorAuthorization.verification.description.p2')}}`} 
			</p>
			<TokenForm />
			<p className={styles.footerText}>
				{t('twoFactorAuthorization.verification.support')}
			</p>
		</div>
	);
};

export default VerificationCodeBlock;
